// 前端
var data = {
    //翻译：用户状态
    TRANSLATE_USER_STATE: {
        1: "启用",
        2: "待处理",
        3: "注销"
    },
    //翻译：是否
    TRNSLATE_SF: {
        0: "否",
        1: "是",
    },
    //翻译：服务类型
    TRNSLATE_SERVICE_TYPE: {
        1: "运维",
        2: "项目施工",
    },
    // 翻译：服务性质
    TRNSLATE_SERVICE_NATURE: {
      0: '公司',
      1: '个人'
    },
    // 翻译：服务请求单类型
    TRNSLATE_WORK_ORDER_CATEGORY: {
      1: '运维',
      2: '工程'
    },
    //数据集：是否
    SF: [
        {value: '', text: '--请选择--'},
        {value : '1', text: '是'},
        {value : '0', text: '否'},
    ],
    //列筛选：服务类型
    FILTER_SERVICE_TYPE: [
        {value : '1', text: '运维'},
        {value : '2', text: '项目施工'},
    ],
    //列筛选：是否
    FILTER_SF: [
        {value : '0', text: '否'},
        {value : '1000', text: '是'},
    ],
    // 签到异常 SIGNIN_EXCEPTION
    SIGNIN_EXCEPTION: [
      {value : '否', text: '否'},
      {value : '是', text: '是'},
    ],
    // 服务商性质
    SERVICE_NATURE: [
      {value : '0', text: '公司'},
      {value : '1', text: '个人'},
    ],
    //列筛选：服务请求单状态
    ORDER_STATE: [
        // {value : '0', text: '可关闭'},
        {value : '1', text: '客服处理'},
        {value : '2', text: '现场处理'},
        // {value : '3', text: '内部验收'},
        {value : '4', text: '服务回访'},
        {value : '5', text: '对账付款'},
        {value : '6', text: '已关闭'},
        {value : '10', text: '草稿'},
        // {value : '11', text: '待接单'},
        // {value : '12', text: '待预约'},
        // {value : '13', text: '待签到'},
        // {value : '14', text: '待自检'},
        // {value : '15', text: '待内部验收'},
        // {value : '16', text: '待签退'},
        // {value : '17', text: '已完成'},
        // {value : '18', text: '已返单'},
    ],
    //列筛选：服务请求单类型
    WORK_ORDER_TYPE: [
        {value : '1', text: '运维'},
        {value : '2', text: '巡检'},
        {value : '3', text: '安装'},
        {value : '5', text: '开店'},
        {value : '6', text: '闭店'},
        {value : '7', text: '改造'},
        {value : '10', text: '集成'},
        {value : '101', text: '非IT维修类型'},
    ],
    //列筛选：SLA等级
    SLA_LEVEL: [
        {value : '1', text: 'P0'},
        {value : '2', text: 'P1'},
        {value : '3', text: 'P2'},
        {value : '4', text: 'P3'},
    ],
    //列筛选：服务方式
    WORK_ORDER_METHOD: [
        {value : '1', text: '上门服务'},
        {value : '2', text: '远程服务'},
        {value : '3', text: '第三方服务'},
    ],
    //列筛选：服务请求单来源
    BILL_SOURCE_METHOD: [
        {value : '1', text: '自建'},
        {value : '2', text: '扫码'},
        {value : '3', text: '微信'},
        {value : '4', text: '电话'},
        {value : '5', text: '钉钉'},
        {value : '6', text: '邮件'},
    ],
    //列筛选：现场服务单状态
    SERVICE_STATE: [
        {value : '0', text: '草稿'},
        {value : '1', text: '待接单'},
        // {value : '2', text: '待预约'},
        {value : '3', text: '待签到'},
        {value : '4', text: '待自检'},
        {value : '5', text: '待内部验收'},
        {value : '6', text: '待签退'},
        {value : '7', text: '已完成'},
        {value : '8', text: '已返单'},
        // {value : '10', text: '验收不通过'},
    ],
    //列筛选：服务请求单类别
    WORK_ORDER_CATEGORY: [
        {value : '1', text: '运维单'},
        {value : '2', text: '工程单'},
    ],
    //列筛选：返单类型
    BACK_ORDER_TYPE: [
        {value : '1', text: '工程师原因'},
        {value : '2', text: '客户原因'},
    ],
    // 是否重新派单
    AFRESH_DISPATCH_ID: [
      {value : '1', text: '是'},
      {value : '0', text: '否'},
    ],
    //列筛选：备件类别
    REPAIR_PART_CATEGORY: [
        {value : '1', text: '临采'},
        {value : '2', text: '备机'},
    ],
    // 是否准时
    EVALUATE_ZS: [
      {value : '1', text: '是'},
      {value : '2', text: '否'},
    ],
    // 是否重新派单
    B_BACK_ORDER: [
      {value : '1', text: '是'},
      {value : '0', text: '否'},
    ],
    //列筛选：回收备件
    REPAIR_PART_RECOVERY: [
        {value : '1', text: '可用'},
        {value : '2', text: '作废'},
    ],
    //列筛选：仓库
    REPAIR_PART_STORE: [
        {value : '1', text: '长沙仓'},
        {value : '2', text: '北京仓'},
        {value : '3', text: '上海仓'},
        {value : '4', text: '深圳仓'},
        {value : '5', text: '广州仓'},
        {value : '6', text: '南京仓'},
        {value : '7', text: '杭州仓'},
    ],
    //列筛选：操作模块
    OPER_MODULE: [
        {value : '1', text: '客户服务请求'},
        {value : '2', text: '现场服务管理'},
    ],
    //列筛选：操作类型
    BUSINESS_TYPE: [
        {value : '1', text: '修改'},
        {value : '2', text: '删除'},
    ],
    //验收结果
    ACCEPTANCE_RESULT: [
      { value: '1', text: '验收通过' },
      { value: '0', text: '验收不通过' }
    ],
    // 客服审核状态
    CUSTOM_SERVICE_APPROVE_STATUS_ID: [
      { value: '8', text: '客服审核通过' },
      { value: '5', text: '客服审核不通过' }
    ],
    INCOME_AMOUNT_TYPE: [
      { value: '2', text: '已付款' },
      { value: '1', text: '未付款' }
    ],
    INCOME_BILL_TYPE: [
      { value: '2', text: '已开票' },
      { value: '1', text: '未开票' }
    ],
    EXPENSES_AMOUNT_TYPE: [
      { value: '3', text: '已付款' },
      { value: '2', text: '待付款' },
      { value: '1', text: '待请款' }
    ],
    EXPENSES_BILL_TYPE: [
      { value: '2', text: '已开票' },
      { value: '1', text: '待开票' },
      { value: '0', text: '劳务' }
    ]
}
// 全局事件常量
var event = {
    LOGIN_SUCCESS: 'LOGIN_SUCCESS',
    LOGOUT: 'LOGOUT',
    UPDATE_USERINFO: 'UPDATE_USERINFO'
}

// 全局常量
var constants = {
    LOGIN_PAGE_PATH: '/login',
    COOKIE_NAME_USER: '_bjkj_user', //每个系统这个cookie需要不一样
}

export default {
    // 翻译方法
    getTranslate : function(domain, value){
        return data[domain] && data[domain][value];
    },
    getData: function(domain){
        return data[domain];
    },
    event : event,
    constants: constants
}



// WEBPACK FOOTER //
// ./src/support/dictionary.js